import { Tooltip } from './styles';

function TooltipText({ children }) {
  return <Tooltip>{children}</Tooltip>;
}

export default TooltipText;
